module.exports = __webpack_public_path__ + "static/media/car-building.20997176.svg";